import { useTranslation } from '@/i18n';
import { TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import styles from './reportFormStatus.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  invoiceId?: string;
};

export const ReportFormStatusNumber: FC<Props> = memo(({ invoiceId }) => {
  const { t } = useTranslation();

  const linkTo = useMemo(() => {
    const url = new URL('/received_invoices', window.location.href);
    url.searchParams.append('id', invoiceId ?? '');
    return url.toString();
  }, [invoiceId]);

  if (!invoiceId) {
    return;
  }
  return (
    <div className={cx(styles['report-form-status-text-wrapper'])}>
      <p className={cx(styles['report-form-status-text-label'])}>
        {t('invoice_id')}
      </p>
      <p className={cx(styles['report-form-status-text-value'])}>
        <TextLink href={linkTo} target='_blank'>
          {invoiceId}
        </TextLink>
      </p>
    </div>
  );
});
ReportFormStatusNumber.displayName = 'ReportForm';
